import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface PasswordFieldsProps {
  formData: Record<string, any>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const PasswordFields: React.FC<PasswordFieldsProps> = ({
  formData,
  onChange
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const inputClass = `mt-1 block w-full rounded-md border sm:text-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.input}`;
  const labelClass = `block text-sm font-medium ${dk.textSecondary}`;
  const fields = [{
    id: 'currentPassword',
    label: 'Current Password',
    show: showCurrentPassword,
    toggle: () => setShowCurrentPassword(!showCurrentPassword)
  }, {
    id: 'newPassword',
    label: 'New Password',
    show: showNewPassword,
    toggle: () => setShowNewPassword(!showNewPassword)
  }, {
    id: 'confirmPassword',
    label: 'Confirm New Password',
    show: showConfirmPassword,
    toggle: () => setShowConfirmPassword(!showConfirmPassword)
  }];
  return <div className="space-y-4" data-id="element-586" data-mp="1pcyl0jup6g1f">
      {fields.map(({
      id,
      label,
      show,
      toggle
    }) => <div key={id} data-id="element-587" data-mp="1u4qhfb0jbfzh">
          <label htmlFor={id} className={labelClass} data-id="element-588" data-mp="1u61fqvb7nvj7">
            {label}
          </label>
          <div className="relative mt-1" data-id="element-589" data-mp="1ged3ms0yp728">
            <input type={show ? 'text' : 'password'} id={id} name={id} value={formData[id] as string || ''} onChange={onChange} className={inputClass} data-id="element-590" data-mp="1lc6alna3a53k" />
            <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={toggle} data-id="element-591" data-mp="1bcnu5gte11g9">
              {show ? <EyeOffIcon className={`h-5 w-5 ${dk.textFaint}`} data-id="element-592" data-mp="nhvkmk3oddj7" /> : <EyeIcon className={`h-5 w-5 ${dk.textFaint}`} data-id="element-593" data-mp="iir9vp13r7qr" />}
            </button>
          </div>
        </div>)}
    </div>;
};